import { defineStore } from "pinia";
import { ref } from "vue";
import { emailPageStates } from "@/components/Buy/BuyEnums";
import { IUserAccountCreationResponse } from "@/common/api/unifiedPortal/interfaces";
import { ReCaptchaInstance } from "recaptcha-v3";

export const useEmailPageStore = defineStore("emailPage", () => {
  const pageState = ref<emailPageStates>(emailPageStates.enterEmail);
  const errorResponseMessage = ref("");
  const isSmbEmail = ref(false);
  const isAolAccount = ref(false);
  const createAccountResponse = ref<IUserAccountCreationResponse>();
  const errorResponseStatus = ref<number>();
  const isCreatingAccount = ref(false);
  const recaptchaInstance = ref<ReCaptchaInstance>();
  const showV2Recaptcha = ref<boolean>(false);
  const captchaV2ResponseToken = ref<string>("");
  const email = ref<string>("");
  const isVerifying = ref<boolean>(false);
  const dirtyFlagEmail = ref(false);
  const showLogInLink = ref(false);
  const showAllstateAlert = ref<boolean>(false);
  const showAllstateAlreadyIncludedAlert = ref<boolean>(false);
  const isSwitchFromLoggedInToEstablished = ref<boolean>(false);
  const editEmailClicked = ref<boolean>(false);

  function reset(skipAccountResponseReset = false) {
    //Clear the previous response
    if (!skipAccountResponseReset) {
      createAccountResponse.value = undefined;
    }
    //Clear the error states in store
    errorResponseMessage.value = "";
    errorResponseStatus.value = undefined;
    isSmbEmail.value = false;
    isAolAccount.value = false;
    showAllstateAlreadyIncludedAlert.value = false;
    showAllstateAlert.value = false;
    isSwitchFromLoggedInToEstablished.value = false;
  }

  return {
    pageState,
    errorResponseMessage,
    isSmbEmail,
    createAccountResponse,
    errorResponseStatus,
    isCreatingAccount,
    isAolAccount,
    reset,
    recaptchaInstance,
    showV2Recaptcha,
    captchaV2ResponseToken,
    email,
    isVerifying,
    dirtyFlagEmail,
    showLogInLink,
    showAllstateAlert,
    showAllstateAlreadyIncludedAlert,
    isSwitchFromLoggedInToEstablished,
    editEmailClicked,
  };
});
